const environment = {
    logo: '/assets/images/logos/logo.png',
    logoLight: '/assets/images/logos/logo_light.png',
    emailContact: process.env.REACT_APP_EMAIL_CONTACT,
    whatsAppContact: process.env.REACT_APP_WHATSAPP_CONTACT,
    websiteUrl: process.env.REACT_APP_WEBSITE_URL,

    // Crops covers
    avocado: '/assets/images/crops covers/Avocado.jpg',
    blueberries: '/assets/images/crops covers/Blueberries.jpg',
    coffee: '/assets/images/crops covers/Coffee.jpg',
    gulupa: '/assets/images/crops covers/Gulupa.jpg',
    palm: '/assets/images/crops covers/Palm.jpg',
    peppermint: '/assets/images/crops covers/Peppermint.jpg',
    plants: '/assets/images/crops covers/Plants.jpg',
    roses: '/assets/images/crops covers/Roses.jpg',
    tomatoes: '/assets/images/crops covers/Tomatoes.jpg',
}

export default environment;